import asyncComponent from '../common/utils/async-component';

const ApiKeys = asyncComponent(() => import('./components/api-keys'));
const ApiKeyCreate = asyncComponent(() => import('./components/api-key-create'));

export default {
  '/api-keys': {
    components: { main: ApiKeys },

    '/create': {
      components: { main: ApiKeyCreate }
    }
  }
};
